/* eslint-disable import/prefer-default-export */

import { isNil } from 'lodash';

import { sanitizeIncomingCustomerDates, sanitizeCustomerCountryAndRegion } from 'views/Agreement/utils';
import { ReduxAgreementRecordFactory } from 'services/Agreements/factories';
import { AgreementCustomer } from 'services/resources';

export const sanitizeIncomingContactlessAgreement = (incomingAgreement) => {
  let agreement = { ...incomingAgreement };
  const entries = Object.entries(incomingAgreement);

  entries.forEach(([key, value]) => {
    const getVal = () => {
      if (isNil(value)) {
        return '';
      }
      return value;
    };
    agreement[key] = getVal();
  });

  const customerAgreementInfo = {} as AgreementCustomer;
  const customerKeys = Object.keys(agreement).filter((key) => key.startsWith('customer'));
  customerKeys.forEach((key) => {
    customerAgreementInfo[key] = agreement[key];
  });

  const sanitizedCustomer = sanitizeIncomingCustomerDates(customerAgreementInfo);

  agreement = {
    ...agreement,
    ...sanitizedCustomer,
  };

  const sanitizedAgreement = sanitizeCustomerCountryAndRegion(agreement);

  return ReduxAgreementRecordFactory(sanitizedAgreement);
};
